import { createClient, createControllerStore, addEventListeners, deepMerge, createPlayerTheme, styling, watchLivepeerProvider, getLivepeerProvider, pick, getAsset, createAsset, updateAsset, getAssetMetrics, getPlaybackInfo, createStream, getStream, getStreamSession, getStreamSessions, updateStream, canPlayMediaNatively, isHlsSupported, createNewHls, getMediaSourceType } from 'livepeer';
export * from 'livepeer';
export { studioProvider } from 'livepeer/providers/studio';
import 'core-js/modules/es.object.assign.js';
import { createSyncStoragePersister } from '@tanstack/query-sync-storage-persister';
import { useMutation, QueryClient } from '@tanstack/react-query';
import { persistQueryClient } from '@tanstack/react-query-persist-client';
import 'core-js/modules/es.array.slice.js';
import 'core-js/modules/es.array.splice.js';
import { T as ThemeContext, _ as _asyncToGenerator, a as _regeneratorRuntime, u as useInternalQuery, b as usePickQueryKeys, Q as QueryClientContext } from './context-ddc40b71.esm.js';
export { C as Context, L as LivepeerConfig, c as ThemeProvider, d as useClient } from './context-ddc40b71.esm.js';
import * as React from 'react';
import { useMemo, useState } from 'react';
import create from 'zustand';
import 'core-js/modules/es.array.map.js';
import 'core-js/modules/es.array.filter.js';
import 'core-js/modules/es.object.to-string.js';
import { useSyncExternalStoreWithSelector } from 'use-sync-external-store/shim/with-selector.js';
import 'core-js/modules/es.array.concat.js';
import 'core-js/modules/es.string.pad-start.js';

function _objectWithoutPropertiesLoose(source, excluded) {
  if (source == null) return {};
  var target = {};
  var sourceKeys = Object.keys(source);
  var key, i;

  for (i = 0; i < sourceKeys.length; i++) {
    key = sourceKeys[i];
    if (excluded.indexOf(key) >= 0) continue;
    target[key] = source[key];
  }

  return target;
}

function _objectWithoutProperties(source, excluded) {
  if (source == null) return {};
  var target = _objectWithoutPropertiesLoose(source, excluded);
  var key, i;

  if (Object.getOwnPropertySymbols) {
    var sourceSymbolKeys = Object.getOwnPropertySymbols(source);

    for (i = 0; i < sourceSymbolKeys.length; i++) {
      key = sourceSymbolKeys[i];
      if (excluded.indexOf(key) >= 0) continue;
      if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
      target[key] = source[key];
    }
  }

  return target;
}

function deserialize(cachedString) {
  var cache = JSON.parse(cachedString);
  return cache;
}

function _defineProperty(obj, key, value) {
  if (key in obj) {
    Object.defineProperty(obj, key, {
      value: value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key] = value;
  }

  return obj;
}

function ownKeys(object, enumerableOnly) {
  var keys = Object.keys(object);

  if (Object.getOwnPropertySymbols) {
    var symbols = Object.getOwnPropertySymbols(object);
    enumerableOnly && (symbols = symbols.filter(function (sym) {
      return Object.getOwnPropertyDescriptor(object, sym).enumerable;
    })), keys.push.apply(keys, symbols);
  }

  return keys;
}

function _objectSpread2(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = null != arguments[i] ? arguments[i] : {};
    i % 2 ? ownKeys(Object(source), !0).forEach(function (key) {
      _defineProperty(target, key, source[key]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) {
      Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
    });
  }

  return target;
}

var usePickMutationKeys = ['cacheTime', 'networkMode', 'onError', 'onMutate', 'onSettled', 'onSuccess', 'retry', 'retryDelay', 'useErrorBoundary', 'meta'];
function useInternalMutation(mutationFn, options) {
  var _useMutation = useMutation(mutationFn, _objectSpread2(_objectSpread2({}, options), {}, {
    useErrorBoundary: false
  })),
      data = _useMutation.data,
      error = _useMutation.error,
      isError = _useMutation.isError,
      isIdle = _useMutation.isIdle,
      isLoading = _useMutation.isLoading,
      isSuccess = _useMutation.isSuccess,
      mutate = _useMutation.mutate,
      mutateAsync = _useMutation.mutateAsync,
      reset = _useMutation.reset,
      variables = _useMutation.variables,
      status = _useMutation.status;

  return {
    data: data,
    error: error,
    isError: isError,
    isIdle: isIdle,
    isLoading: isLoading,
    isSuccess: isSuccess,
    mutate: mutate,
    mutateAsync: mutateAsync,
    variables: variables,
    status: status,
    internal: {
      reset: reset
    }
  };
}

function _typeof(obj) {
  "@babel/helpers - typeof";

  return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) {
    return typeof obj;
  } : function (obj) {
    return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
  }, _typeof(obj);
}

/**
 * @function getReferenceKey
 *
 * @description
 * get the reference key for the circular value
 *
 * @param keys the keys to build the reference key from
 * @param cutoff the maximum number of keys to include
 * @returns the reference key
 */
function getReferenceKey(keys, cutoff) {
  return keys.slice(0, cutoff).join('.') || '.';
}
/**
 * @function getCutoff
 *
 * @description
 * faster `Array.prototype.indexOf` implementation build for slicing / splicing
 *
 * @param array the array to match the value in
 * @param value the value to match
 * @returns the matching index, or -1
 */


function getCutoff(array, value) {
  var length = array.length;

  for (var index = 0; index < length; ++index) {
    if (array[index] === value) {
      return index + 1;
    }
  }

  return 0;
}

/**
 * @function createReplacer
 *
 * @description
 * create a replacer method that handles circular values
 *
 * @param [replacer] a custom replacer to use for non-circular values
 * @param [circularReplacer] a custom replacer to use for circular methods
 * @returns the value to stringify
 */
function createReplacer(replacer, circularReplacer) {
  var hasReplacer = typeof replacer === 'function';
  var hasCircularReplacer = typeof circularReplacer === 'function';
  var cache = [];
  var keys = [];
  return function replace(key, value) {
    if (_typeof(value) === 'object') {
      if (cache.length) {
        var thisCutoff = getCutoff(cache, this);

        if (thisCutoff === 0) {
          cache[cache.length] = this;
        } else {
          cache.splice(thisCutoff);
          keys.splice(thisCutoff);
        }

        keys[keys.length] = key;
        var valueCutoff = getCutoff(cache, value);

        if (valueCutoff !== 0) {
          return hasCircularReplacer ? circularReplacer.call(this, key, value, getReferenceKey(keys, valueCutoff)) : "[ref=".concat(getReferenceKey(keys, valueCutoff), "]");
        }
      } else {
        cache[0] = value;
        keys[0] = key;
      }
    }

    return hasReplacer ? replacer.call(this, key, value) : value;
  };
}
/**
 * @function stringify
 *
 * @description
 * stringifier that handles circular values
 * Forked from https://github.com/planttheidea/fast-stringify
 *
 * @param value to stringify
 * @param [replacer] a custom replacer function for handling standard values
 * @param [indent] the number of spaces to indent the output by
 * @param [circularReplacer] a custom replacer function for handling circular values
 * @returns the stringified output
 */


function serialize(value, replacer, indent, circularReplacer) {
  return JSON.stringify(value, createReplacer(replacer, circularReplacer), indent !== null && indent !== void 0 ? indent : undefined);
}

var _excluded$4 = ["queryClient"];
function createReactClient(_ref) {
  var _config$storage;

  var _ref$queryClient = _ref.queryClient,
      queryClient = _ref$queryClient === void 0 ? new QueryClient({
    defaultOptions: {
      queries: {
        cacheTime: 1000 * 60 * 60 * 24,
        // 24 hours
        networkMode: 'offlineFirst',
        refetchOnWindowFocus: false,
        retry: 0
      },
      mutations: {
        networkMode: 'offlineFirst'
      }
    }
  }) : _ref$queryClient,
      config = _objectWithoutProperties(_ref, _excluded$4);

  var client = createClient(config);
  var persister = typeof window !== 'undefined' ? createSyncStoragePersister({
    key: 'livepeer.cache',
    storage: (_config$storage = config === null || config === void 0 ? void 0 : config.storage) !== null && _config$storage !== void 0 ? _config$storage : window.localStorage,
    serialize: serialize,
    deserialize: deserialize
  }) : undefined;
  if (persister) persistQueryClient({
    queryClient: queryClient,
    persister: persister,
    dehydrateOptions: {
      shouldDehydrateQuery: function shouldDehydrateQuery(query) {
        return query.cacheTime !== 0;
      }
    }
  });
  return Object.assign(client, {
    queryClient: queryClient
  });
}

var MediaControllerContext = /*#__PURE__*/React.createContext(create(createControllerStore(null)));

var MediaControllerProvider = function MediaControllerProvider(_ref) {
  var element = _ref.element,
      children = _ref.children,
      options = _ref.options;
  var useMediaController = useMediaControllerStore(element, options);
  return /*#__PURE__*/React.createElement(MediaControllerContext.Provider, {
    value: useMediaController
  }, children);
};

var useMediaControllerStore = function useMediaControllerStore(element, options) {
  var useStore = React.useMemo(function () {
    return create(createControllerStore(element));
  }, [element]);
  React.useEffect(function () {
    var _addEventListeners = addEventListeners(useStore, options),
        destroy = _addEventListeners.destroy;

    return function () {
      destroy === null || destroy === void 0 ? void 0 : destroy();
    };
  }, [useStore, options]);
  return useStore;
};

var useMediaController = function useMediaController(selector) {
  // typecast the context so that we can have video/audio-specific controller states
  var useMediaControllerInternal = React.useContext(MediaControllerContext);
  return useMediaControllerInternal(selector);
};

var useTheme = function useTheme(theme) {
  var contextTheme = React.useContext(ThemeContext);
  var containerTheme = React.useMemo(function () {
    var mergedTheme = contextTheme ? theme ? deepMerge(contextTheme, theme) : contextTheme : theme;
    return mergedTheme ? createPlayerTheme(mergedTheme) : undefined;
  }, [theme, contextTheme]);
  return containerTheme;
};

function _arrayWithHoles(arr) {
  if (Array.isArray(arr)) return arr;
}

function _iterableToArrayLimit(arr, i) {
  var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"];

  if (_i == null) return;
  var _arr = [];
  var _n = true;
  var _d = false;

  var _s, _e;

  try {
    for (_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true) {
      _arr.push(_s.value);

      if (i && _arr.length === i) break;
    }
  } catch (err) {
    _d = true;
    _e = err;
  } finally {
    try {
      if (!_n && _i["return"] != null) _i["return"]();
    } finally {
      if (_d) throw _e;
    }
  }

  return _arr;
}

function _arrayLikeToArray(arr, len) {
  if (len == null || len > arr.length) len = arr.length;

  for (var i = 0, arr2 = new Array(len); i < len; i++) arr2[i] = arr[i];

  return arr2;
}

function _unsupportedIterableToArray(o, minLen) {
  if (!o) return;
  if (typeof o === "string") return _arrayLikeToArray(o, minLen);
  var n = Object.prototype.toString.call(o).slice(8, -1);
  if (n === "Object" && o.constructor) n = o.constructor.name;
  if (n === "Map" || n === "Set") return Array.from(o);
  if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen);
}

function _nonIterableRest() {
  throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}

function _slicedToArray(arr, i) {
  return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest();
}

/**
 * As prop
 */

var useConditionalIcon = function useConditionalIcon(conditional, truthyIcon, truthyDefaultIcon, falsyIcon, falsyDefaultIcon) {
  var element = React.useMemo(function () {
    return conditional ? truthyIcon !== null && truthyIcon !== void 0 ? truthyIcon : truthyDefaultIcon : falsyIcon !== null && falsyIcon !== void 0 ? falsyIcon : falsyDefaultIcon;
  }, [conditional, truthyIcon, truthyDefaultIcon, falsyIcon, falsyDefaultIcon]);
  return React.useMemo(function () {
    return /*#__PURE__*/React.isValidElement(element) ? /*#__PURE__*/React.cloneElement(element) : null;
  }, [element]);
};
var useMemoizedIcon = function useMemoizedIcon(icon, defaultIcon) {
  return React.useMemo(function () {
    return icon && /*#__PURE__*/React.isValidElement(icon) ? /*#__PURE__*/React.cloneElement(icon) : defaultIcon;
  }, [icon, defaultIcon]);
};

var mediaControllerSelector$b = function mediaControllerSelector(_ref) {
  var device = _ref.device;
  return {
    device: device
  };
};

var BaseSlider = function BaseSlider(props) {
  var _useMediaController = useMediaController(mediaControllerSelector$b),
      device = _useMediaController.device;

  var ref = React.useRef(null);

  var _React$useState = React.useState(false),
      _React$useState2 = _slicedToArray(_React$useState, 2),
      isActive = _React$useState2[0],
      setIsActive = _React$useState2[1];

  var _React$useState3 = React.useState(false),
      _React$useState4 = _slicedToArray(_React$useState3, 2),
      isDragging = _React$useState4[0],
      setIsDragging = _React$useState4[1];

  var isActiveOrDragging = React.useMemo(function () {
    return (device === null || device === void 0 ? void 0 : device.isMobile) || isActive || isDragging;
  }, [device === null || device === void 0 ? void 0 : device.isMobile, isActive, isDragging]);
  var onUpdate = React.useCallback( /*#__PURE__*/function () {
    var _ref2 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee(eventX) {
      var _ref$current;

      var bounding, _props$onChange, newValue, newBoundedValue;

      return _regeneratorRuntime().wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              bounding = (_ref$current = ref.current) === null || _ref$current === void 0 ? void 0 : _ref$current.getBoundingClientRect();

              if (!bounding) {
                _context.next = 6;
                break;
              }

              newValue = (eventX - bounding.left) / bounding.width;
              newBoundedValue = Math.min(Math.max(0, newValue), 1);
              _context.next = 6;
              return props === null || props === void 0 ? void 0 : (_props$onChange = props.onChange) === null || _props$onChange === void 0 ? void 0 : _props$onChange.call(props, newBoundedValue);

            case 6:
            case "end":
              return _context.stop();
          }
        }
      }, _callee);
    }));

    return function (_x) {
      return _ref2.apply(this, arguments);
    };
  }(), [props]);
  React.useEffect(function () {
    if (isDragging) {
      var _document, _document2, _document3, _document4;

      var onMouseMove = /*#__PURE__*/function () {
        var _ref3 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee2(e) {
          return _regeneratorRuntime().wrap(function _callee2$(_context2) {
            while (1) {
              switch (_context2.prev = _context2.next) {
                case 0:
                  _context2.next = 2;
                  return onUpdate(e.clientX);

                case 2:
                case "end":
                  return _context2.stop();
              }
            }
          }, _callee2);
        }));

        return function onMouseMove(_x2) {
          return _ref3.apply(this, arguments);
        };
      }();

      var onTouchMove = /*#__PURE__*/function () {
        var _ref4 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee3(e) {
          var _e$touches, _e$touches$item, _e$touches$item$call;

          var clientX;
          return _regeneratorRuntime().wrap(function _callee3$(_context3) {
            while (1) {
              switch (_context3.prev = _context3.next) {
                case 0:
                  clientX = (_e$touches = e.touches) === null || _e$touches === void 0 ? void 0 : (_e$touches$item = _e$touches.item) === null || _e$touches$item === void 0 ? void 0 : (_e$touches$item$call = _e$touches$item.call(_e$touches, 0)) === null || _e$touches$item$call === void 0 ? void 0 : _e$touches$item$call.clientX;

                  if (!clientX) {
                    _context3.next = 4;
                    break;
                  }

                  _context3.next = 4;
                  return onUpdate(clientX);

                case 4:
                case "end":
                  return _context3.stop();
              }
            }
          }, _callee3);
        }));

        return function onTouchMove(_x3) {
          return _ref4.apply(this, arguments);
        };
      }();

      var onMouseUp = /*#__PURE__*/function () {
        var _ref5 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee4(e) {
          var _props$onDone;

          return _regeneratorRuntime().wrap(function _callee4$(_context4) {
            while (1) {
              switch (_context4.prev = _context4.next) {
                case 0:
                  setIsDragging(false);
                  _context4.next = 3;
                  return onUpdate(e.clientX);

                case 3:
                  _context4.next = 5;
                  return props === null || props === void 0 ? void 0 : (_props$onDone = props.onDone) === null || _props$onDone === void 0 ? void 0 : _props$onDone.call(props);

                case 5:
                case "end":
                  return _context4.stop();
              }
            }
          }, _callee4);
        }));

        return function onMouseUp(_x4) {
          return _ref5.apply(this, arguments);
        };
      }();

      var onTouchEnd = /*#__PURE__*/function () {
        var _ref6 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee5(e) {
          var _e$touches2, _e$touches2$item, _e$touches2$item$call, _props$onDone2;

          var clientX;
          return _regeneratorRuntime().wrap(function _callee5$(_context5) {
            while (1) {
              switch (_context5.prev = _context5.next) {
                case 0:
                  setIsDragging(false);
                  clientX = (_e$touches2 = e.touches) === null || _e$touches2 === void 0 ? void 0 : (_e$touches2$item = _e$touches2.item) === null || _e$touches2$item === void 0 ? void 0 : (_e$touches2$item$call = _e$touches2$item.call(_e$touches2, 0)) === null || _e$touches2$item$call === void 0 ? void 0 : _e$touches2$item$call.clientX;

                  if (!clientX) {
                    _context5.next = 5;
                    break;
                  }

                  _context5.next = 5;
                  return onUpdate(clientX);

                case 5:
                  _context5.next = 7;
                  return props === null || props === void 0 ? void 0 : (_props$onDone2 = props.onDone) === null || _props$onDone2 === void 0 ? void 0 : _props$onDone2.call(props);

                case 7:
                case "end":
                  return _context5.stop();
              }
            }
          }, _callee5);
        }));

        return function onTouchEnd(_x5) {
          return _ref6.apply(this, arguments);
        };
      }();

      (_document = document) === null || _document === void 0 ? void 0 : _document.addEventListener('mousemove', onMouseMove);
      (_document2 = document) === null || _document2 === void 0 ? void 0 : _document2.addEventListener('mouseup', onMouseUp);
      (_document3 = document) === null || _document3 === void 0 ? void 0 : _document3.addEventListener('touchmove', onTouchMove);
      (_document4 = document) === null || _document4 === void 0 ? void 0 : _document4.addEventListener('touchend', onTouchEnd); // TODO handle mouse out

      return function () {
        var _document5, _document6, _document7, _document8;

        (_document5 = document) === null || _document5 === void 0 ? void 0 : _document5.removeEventListener('mousemove', onMouseMove);
        (_document6 = document) === null || _document6 === void 0 ? void 0 : _document6.removeEventListener('mouseup', onMouseUp);
        (_document7 = document) === null || _document7 === void 0 ? void 0 : _document7.removeEventListener('touchmove', onTouchMove);
        (_document8 = document) === null || _document8 === void 0 ? void 0 : _document8.removeEventListener('touchend', onTouchEnd);
      };
    }
  }, [isDragging, onUpdate, props]);

  var _handle = useMemoizedIcon(props === null || props === void 0 ? void 0 : props.thumbIcon, /*#__PURE__*/React.createElement("div", {
    className: styling.slider.thumb()
  }));

  var _React$useMemo = React.useMemo(function () {
    return [!isNaN(props.value) ? props.value : 0, props.secondaryValue && !isNaN(props.value) && !isNaN(props.secondaryValue) ? props.secondaryValue - props.value : 0];
  }, [props.value, props.secondaryValue]),
      _React$useMemo2 = _slicedToArray(_React$useMemo, 2),
      value = _React$useMemo2[0],
      middleValue = _React$useMemo2[1];

  var rightValue = React.useMemo(function () {
    return 1 - (value + middleValue);
  }, [value, middleValue]);
  var onPointerDown = React.useCallback( /*#__PURE__*/function () {
    var _ref7 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee6(e) {
      return _regeneratorRuntime().wrap(function _callee6$(_context6) {
        while (1) {
          switch (_context6.prev = _context6.next) {
            case 0:
              _context6.next = 2;
              return onUpdate(e.clientX);

            case 2:
              setIsDragging(true);

            case 3:
            case "end":
              return _context6.stop();
          }
        }
      }, _callee6);
    }));

    return function (_x6) {
      return _ref7.apply(this, arguments);
    };
  }(), [onUpdate]);
  var onMouseEnter = React.useCallback( /*#__PURE__*/_asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee7() {
    return _regeneratorRuntime().wrap(function _callee7$(_context7) {
      while (1) {
        switch (_context7.prev = _context7.next) {
          case 0:
            setIsActive(true);

          case 1:
          case "end":
            return _context7.stop();
        }
      }
    }, _callee7);
  })), [setIsActive]);
  var onMouseLeave = React.useCallback( /*#__PURE__*/_asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee8() {
    return _regeneratorRuntime().wrap(function _callee8$(_context8) {
      while (1) {
        switch (_context8.prev = _context8.next) {
          case 0:
            setIsActive(false);

          case 1:
          case "end":
            return _context8.stop();
        }
      }
    }, _callee8);
  })), [setIsActive]);
  var valueRounded = React.useMemo(function () {
    return Math.round(value * 100);
  }, [value]);
  return /*#__PURE__*/React.createElement("div", {
    ref: ref,
    onPointerDown: onPointerDown,
    onMouseEnter: onMouseEnter,
    onMouseLeave: onMouseLeave,
    role: "slider",
    "aria-valuemin": 0,
    "aria-valuemax": 100,
    "aria-valuenow": valueRounded,
    "aria-valuetext": "".concat(valueRounded, "% ").concat(props.ariaName),
    "aria-orientation": "horizontal",
    className: styling.slider.container()
  }, value > 0.001 && /*#__PURE__*/React.createElement("div", {
    className: styling.slider.track.left({
      size: isActiveOrDragging ? 'active' : 'default',
      rounded: value === 1 && !isActiveOrDragging ? 'full' : 'left',
      css: {
        flex: value
      }
    })
  }), isActiveOrDragging && _handle, (middleValue !== null && middleValue !== void 0 ? middleValue : 0) > 0 && /*#__PURE__*/React.createElement("div", {
    className: styling.slider.track.middle({
      size: isActiveOrDragging ? 'active' : 'default',
      rounded: middleValue === 1 ? !isActiveOrDragging ? 'full' : 'right' : value <= 0.001 ? 'left' : rightValue === 0 ? 'right' : 'none',
      css: {
        flex: middleValue
      }
    })
  }), (rightValue !== null && rightValue !== void 0 ? rightValue : 0) > 0 && /*#__PURE__*/React.createElement("div", {
    className: styling.slider.track.right({
      size: isActiveOrDragging ? 'active' : 'default',
      rounded: value <= 0.001 && !isActiveOrDragging ? 'full' : 'right',
      css: {
        flex: rightValue
      }
    })
  }));
};

var mediaControllerSelector$a = function mediaControllerSelector(_ref) {
  var fullscreen = _ref.fullscreen;
  return {
    fullscreen: fullscreen
  };
};

var Container = /*#__PURE__*/React.forwardRef(function (props, ref) {
  var children = props.children,
      className = props.className,
      aspectRatio = props.aspectRatio;

  var _useMediaController = useMediaController(mediaControllerSelector$a),
      fullscreen = _useMediaController.fullscreen;

  return /*#__PURE__*/React.createElement("div", {
    style: {
      display: 'contents'
    },
    className: className
  }, /*#__PURE__*/React.createElement("div", {
    className: styling.container({
      aspectRatio: aspectRatio,
      size: fullscreen ? 'fullscreen' : 'default'
    }),
    ref: ref,
    tabIndex: 0
  }, children));
});
Container.displayName = 'Container';

var mediaControllerSelector$9 = function mediaControllerSelector(_ref) {
  var hidden = _ref.hidden,
      togglePlay = _ref.togglePlay,
      canPlay = _ref.canPlay,
      hasPlayed = _ref.hasPlayed,
      buffered = _ref.buffered;
  return {
    hidden: hidden,
    togglePlay: togglePlay,
    canPlay: canPlay,
    hasPlayed: hasPlayed,
    buffered: buffered
  };
};

var ControlsContainer = /*#__PURE__*/React.forwardRef(function (props, ref) {
  var top = props.top,
      middle = props.middle,
      left = props.left,
      right = props.right,
      poster = props.poster,
      _props$showLoadingSpi = props.showLoadingSpinner,
      showLoadingSpinner = _props$showLoadingSpi === void 0 ? true : _props$showLoadingSpi,
      _props$hidePosterOnPl = props.hidePosterOnPlayed,
      hidePosterOnPlayed = _props$hidePosterOnPl === void 0 ? true : _props$hidePosterOnPl;

  var _useMediaController = useMediaController(mediaControllerSelector$9),
      hidden = _useMediaController.hidden,
      togglePlay = _useMediaController.togglePlay,
      canPlay = _useMediaController.canPlay,
      hasPlayed = _useMediaController.hasPlayed,
      buffered = _useMediaController.buffered;

  var isLoaded = React.useMemo(function () {
    return canPlay || buffered !== 0;
  }, [canPlay, buffered]);
  var onClickBackground = React.useCallback(function () {
    if (isLoaded) {
      togglePlay();
    }
  }, [togglePlay, isLoaded]);
  return /*#__PURE__*/React.createElement(React.Fragment, null, poster ? /*#__PURE__*/React.createElement("div", {
    className: styling.controlsContainer.background({
      display: hasPlayed && hidePosterOnPlayed ? 'hidden' : 'shown'
    }),
    onMouseUp: onClickBackground
  }, poster) : /*#__PURE__*/React.createElement("div", {
    className: styling.controlsContainer.background({
      display: 'hidden'
    }),
    onMouseUp: onClickBackground
  }), showLoadingSpinner && !isLoaded && /*#__PURE__*/React.createElement("div", {
    className: styling.controlsContainer.background(),
    onMouseUp: onClickBackground
  }, /*#__PURE__*/React.createElement("div", {
    className: styling.controlsContainer.loading()
  })), isLoaded && /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("div", {
    className: styling.controlsContainer.gradient({
      display: hidden ? 'hidden' : 'shown'
    }),
    onMouseUp: onClickBackground
  }), /*#__PURE__*/React.createElement("div", {
    className: styling.controlsContainer.top.container({
      display: hidden ? 'hidden' : 'shown'
    })
  }, top), /*#__PURE__*/React.createElement("div", {
    className: styling.controlsContainer.bottom.container({
      display: hidden ? 'hidden' : 'shown'
    }),
    ref: ref
  }, /*#__PURE__*/React.createElement("div", {
    className: styling.controlsContainer.bottom.middle.container()
  }, middle), /*#__PURE__*/React.createElement("div", {
    className: styling.controlsContainer.bottom.lower.container()
  }, /*#__PURE__*/React.createElement("div", {
    className: styling.controlsContainer.bottom.lower.left()
  }, left), /*#__PURE__*/React.createElement("div", {
    className: styling.controlsContainer.bottom.lower.right()
  }, right)))));
});
ControlsContainer.displayName = 'ControlsContainer';

function _extends() {
  _extends = Object.assign ? Object.assign.bind() : function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];

      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }

    return target;
  };
  return _extends.apply(this, arguments);
}

var _excluded$3 = ["enterIcon", "exitIcon", "onClick"];

var DefaultEnterFullscreenIcon = function DefaultEnterFullscreenIcon() {
  return /*#__PURE__*/React.createElement("svg", {
    width: "100%",
    height: "100%",
    viewBox: "0 0 36 36",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "m 10,16 2,0 0,-4 4,0 0,-2 L 10,10 l 0,6 0,0 z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "m 20,10 0,2 4,0 0,4 2,0 L 26,10 l -6,0 0,0 z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "m 24,24 -4,0 0,2 L 26,26 l 0,-6 -2,0 0,4 0,0 z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M 12,20 10,20 10,26 l 6,0 0,-2 -4,0 0,-4 0,0 z"
  }));
};

var DefaultExitFullscreenIcon = function DefaultExitFullscreenIcon() {
  return /*#__PURE__*/React.createElement("svg", {
    width: "100%",
    height: "100%",
    viewBox: "0 0 36 36",
    xmlns: "http://www.w3.org/2000/svg"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "m 14,14 -4,0 0,2 6,0 0,-6 -2,0 0,4 0,0 z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "m 22,14 0,-4 -2,0 0,6 6,0 0,-2 -4,0 0,0 z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "m 20,26 2,0 0,-4 4,0 0,-2 -6,0 0,6 0,0 z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "m 10,22 4,0 0,4 2,0 0,-6 -6,0 0,2 0,0 z"
  }));
};

var mediaControllerSelector$8 = function mediaControllerSelector(_ref) {
  var fullscreen = _ref.fullscreen,
      requestToggleFullscreen = _ref.requestToggleFullscreen;
  return {
    fullscreen: fullscreen,
    requestToggleFullscreen: requestToggleFullscreen
  };
};

var FullscreenButton = /*#__PURE__*/React.forwardRef(function (props, ref) {
  var _useMediaController = useMediaController(mediaControllerSelector$8),
      fullscreen = _useMediaController.fullscreen,
      requestToggleFullscreen = _useMediaController.requestToggleFullscreen;

  var enterIcon = props.enterIcon,
      exitIcon = props.exitIcon,
      onClick = props.onClick,
      rest = _objectWithoutProperties(props, _excluded$3);

  var onClickComposed = React.useCallback( /*#__PURE__*/function () {
    var _ref2 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee(e) {
      return _regeneratorRuntime().wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              _context.next = 2;
              return onClick === null || onClick === void 0 ? void 0 : onClick(e);

            case 2:
              _context.next = 4;
              return requestToggleFullscreen();

            case 4:
            case "end":
              return _context.stop();
          }
        }
      }, _callee);
    }));

    return function (_x) {
      return _ref2.apply(this, arguments);
    };
  }(), [onClick, requestToggleFullscreen]);

  var _children = useConditionalIcon(fullscreen, exitIcon, /*#__PURE__*/React.createElement(DefaultExitFullscreenIcon, null), enterIcon, /*#__PURE__*/React.createElement(DefaultEnterFullscreenIcon, null));

  var title = React.useMemo(function () {
    return fullscreen ? 'Exit full screen (f)' : 'Full screen (f)';
  }, [fullscreen]);
  return /*#__PURE__*/React.createElement("button", _extends({}, rest, {
    className: styling.iconButton(),
    title: title,
    "aria-label": title,
    ref: ref,
    onClick: onClickComposed
  }), _children);
});
FullscreenButton.displayName = 'FullscreenButton';

var _excluded$2 = ["playIcon", "pauseIcon", "onClick"];

var DefaultPlayIcon = function DefaultPlayIcon() {
  return /*#__PURE__*/React.createElement("svg", {
    width: "100%",
    height: "100%",
    viewBox: "0 0 36 36",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 12,26 18.5,22 18.5,14 12,10 z M 18.5,22 25,18 25,18 18.5,14 z",
    fill: "currentColor"
  }));
};

var DefaultPauseIcon = function DefaultPauseIcon() {
  return /*#__PURE__*/React.createElement("svg", {
    width: "100%",
    height: "100%",
    viewBox: "0 0 36 36",
    fill: "none"
  }, /*#__PURE__*/React.createElement("path", {
    // fillRule="evenodd"
    // clipRule="evenodd"
    d: "M 12,26 16,26 16,10 12,10 z M 21,26 25,26 25,10 21,10 z",
    fill: "currentColor"
  }));
};

var mediaControllerSelector$7 = function mediaControllerSelector(_ref) {
  var togglePlay = _ref.togglePlay,
      playing = _ref.playing;
  return {
    togglePlay: togglePlay,
    playing: playing
  };
};

var PlayButton = /*#__PURE__*/React.forwardRef(function (props, ref) {
  var _useMediaController = useMediaController(mediaControllerSelector$7),
      togglePlay = _useMediaController.togglePlay,
      playing = _useMediaController.playing;

  var playIcon = props.playIcon,
      pauseIcon = props.pauseIcon,
      onClick = props.onClick,
      rest = _objectWithoutProperties(props, _excluded$2);

  var onClickComposed = /*#__PURE__*/function () {
    var _ref2 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee(e) {
      return _regeneratorRuntime().wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              _context.next = 2;
              return onClick === null || onClick === void 0 ? void 0 : onClick(e);

            case 2:
              _context.next = 4;
              return togglePlay();

            case 4:
            case "end":
              return _context.stop();
          }
        }
      }, _callee);
    }));

    return function onClickComposed(_x) {
      return _ref2.apply(this, arguments);
    };
  }();

  var _children = useConditionalIcon(playing, pauseIcon, /*#__PURE__*/React.createElement(DefaultPauseIcon, null), playIcon, /*#__PURE__*/React.createElement(DefaultPlayIcon, null));

  var title = React.useMemo(function () {
    return playing ? 'Pause (k)' : 'Play (k)';
  }, [playing]);
  return /*#__PURE__*/React.createElement("button", _extends({}, rest, {
    className: styling.iconButton(),
    title: title,
    "aria-label": title,
    ref: ref,
    onClick: onClickComposed
  }), _children);
});

var mediaControllerSelector$6 = function mediaControllerSelector(_ref) {
  var fullscreen = _ref.fullscreen;
  return {
    fullscreen: fullscreen
  };
};

var Poster = /*#__PURE__*/React.forwardRef(function (props, ref) {
  var _useMediaController = useMediaController(mediaControllerSelector$6),
      fullscreen = _useMediaController.fullscreen;

  var content = props.content,
      title = props.title;
  return typeof content === 'string' ? /*#__PURE__*/React.createElement("img", {
    className: styling.media.poster({
      size: fullscreen ? 'fullscreen' : 'default'
    }),
    "aria-label": title,
    alt: title,
    ref: ref,
    src: content
  }) : /*#__PURE__*/React.isValidElement(content) ? /*#__PURE__*/React.cloneElement(content, {
    className: styling.media.poster({
      size: fullscreen ? 'fullscreen' : 'default'
    })
  }) : /*#__PURE__*/React.createElement(React.Fragment, null);
});

var mediaControllerSelector$5 = function mediaControllerSelector(_ref) {
  var duration = _ref.duration,
      progress = _ref.progress,
      requestSeek = _ref.requestSeek,
      buffered = _ref.buffered;
  return {
    duration: duration,
    progress: progress,
    requestSeek: requestSeek,
    buffered: buffered
  };
};

var Progress = function Progress(props) {
  var _useMediaController = useMediaController(mediaControllerSelector$5),
      duration = _useMediaController.duration,
      progress = _useMediaController.progress,
      requestSeek = _useMediaController.requestSeek,
      buffered = _useMediaController.buffered;

  var _React$useMemo = React.useMemo(function () {
    return [0, duration && !isNaN(duration) ? duration : 0, progress && !isNaN(progress) ? progress : 0];
  }, [duration, progress]),
      _React$useMemo2 = _slicedToArray(_React$useMemo, 3),
      min = _React$useMemo2[0],
      max = _React$useMemo2[1],
      current = _React$useMemo2[2];

  var value = React.useMemo(function () {
    return current / (max - min);
  }, [min, max, current]);
  var secondaryValue = React.useMemo(function () {
    return buffered / (max - min);
  }, [min, max, buffered]);
  var onChange = React.useCallback( /*#__PURE__*/function () {
    var _ref2 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee(value) {
      var _props$onSeek;

      var newSeek;
      return _regeneratorRuntime().wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              newSeek = value * (max - min);
              _context.next = 3;
              return props === null || props === void 0 ? void 0 : (_props$onSeek = props.onSeek) === null || _props$onSeek === void 0 ? void 0 : _props$onSeek.call(props, newSeek);

            case 3:
              requestSeek(newSeek);

            case 4:
            case "end":
              return _context.stop();
          }
        }
      }, _callee);
    }));

    return function (_x) {
      return _ref2.apply(this, arguments);
    };
  }(), [max, min, requestSeek, props]);
  var durationMinutes = React.useMemo(function () {
    return (duration / 60).toFixed(1);
  }, [duration]);
  return /*#__PURE__*/React.createElement(BaseSlider, {
    ariaName: "progress of ".concat(durationMinutes, " minutes"),
    value: value,
    secondaryValue: secondaryValue,
    onChange: onChange
  });
};

var mediaControllerSelector$4 = function mediaControllerSelector(_ref) {
  var duration = _ref.duration,
      progress = _ref.progress,
      live = _ref.live;
  return {
    duration: duration,
    progress: progress,
    live: live
  };
};

var getFormattedMinutesAndSeconds = function getFormattedMinutesAndSeconds(valueInSeconds) {
  if (valueInSeconds !== null && !isNaN(valueInSeconds) && isFinite(valueInSeconds)) {
    var minutes = Math.floor(valueInSeconds / 60);
    var seconds = Math.round(valueInSeconds % 60);
    return "".concat(minutes.toFixed(0), ":").concat(seconds.toFixed(0).padStart(2, '0'));
  }

  return "0:00";
};

var TimeDisplay = /*#__PURE__*/React.forwardRef(function (props, ref) {
  var _useMediaController = useMediaController(mediaControllerSelector$4),
      duration = _useMediaController.duration,
      progress = _useMediaController.progress,
      live = _useMediaController.live;

  var formattedProgress = React.useMemo(function () {
    return getFormattedMinutesAndSeconds(progress !== null && progress !== void 0 ? progress : 0);
  }, [progress]);
  var formattedDuration = React.useMemo(function () {
    return getFormattedMinutesAndSeconds(duration !== null && duration !== void 0 ? duration : null);
  }, [duration]);
  var formattedTime = React.useMemo(function () {
    return live ? formattedProgress : "".concat(formattedProgress, " / ").concat(formattedDuration);
  }, [formattedProgress, formattedDuration, live]);
  return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("span", _extends({
    className: styling.time.text(),
    "aria-label": 'Playback time',
    ref: ref
  }, props), formattedTime), live && /*#__PURE__*/React.createElement("div", {
    className: styling.time.container()
  }, /*#__PURE__*/React.createElement("div", {
    className: styling.time.liveIndicator()
  }), /*#__PURE__*/React.createElement("span", _extends({
    className: styling.time.text(),
    "aria-label": 'Live streaming media',
    ref: ref
  }, props), "LIVE")));
});

var _excluded$1 = ["content"];
var Title = /*#__PURE__*/React.forwardRef(function (props, ref) {
  var content = props.content,
      rest = _objectWithoutProperties(props, _excluded$1);

  return /*#__PURE__*/React.createElement("span", _extends({
    className: styling.title(),
    "aria-label": 'Title',
    ref: ref
  }, rest), content);
});

var _excluded = ["unmutedIcon", "mutedIcon", "onClick", "showSlider"];

var DefaultMutedIcon = function DefaultMutedIcon() {
  return /*#__PURE__*/React.createElement("svg", {
    width: "100%",
    height: "100%",
    viewBox: "0 0 36 36"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 9.25,9 7.98,10.27 24.71,27 l 1.27,-1.27 Z",
    fill: "currentColor"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M8,21 L12,21 L17,26 L17,10 L12,15 L8,15 L8,21 Z M19,14 L19,22 C20.48,21.32 21.5,19.77 21.5,18 C21.5,16.26 20.48,14.74 19,14 ZM19,11.29 C21.89,12.15 24,14.83 24,18 C24,21.17 21.89,23.85 19,24.71 L19,26.77 C23.01,25.86 26,22.28 26,18 C26,13.72 23.01,10.14 19,9.23 L19,11.29 Z"
  }));
};

var DefaultUnmutedIcon = function DefaultUnmutedIcon() {
  return /*#__PURE__*/React.createElement("svg", {
    width: "100%",
    height: "100%",
    viewBox: "0 0 36 36"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M8,21 L12,21 L17,26 L17,10 L12,15 L8,15 L8,21 Z M19,14 L19,22 C20.48,21.32 21.5,19.77 21.5,18 C21.5,16.26 20.48,14.74 19,14 ZM19,11.29 C21.89,12.15 24,14.83 24,18 C24,21.17 21.89,23.85 19,24.71 L19,26.77 C23.01,25.86 26,22.28 26,18 C26,13.72 23.01,10.14 19,9.23 L19,11.29 Z"
  }));
};

var mediaControllerSelector$3 = function mediaControllerSelector(_ref) {
  var isVolumeChangeSupported = _ref.isVolumeChangeSupported,
      requestToggleMute = _ref.requestToggleMute,
      requestVolume = _ref.requestVolume,
      muted = _ref.muted;
  return {
    isVolumeChangeSupported: isVolumeChangeSupported,
    requestToggleMute: requestToggleMute,
    requestVolume: requestVolume,
    muted: muted
  };
};

var Volume = /*#__PURE__*/React.forwardRef(function (props, ref) {
  var _useMediaController = useMediaController(mediaControllerSelector$3),
      requestToggleMute = _useMediaController.requestToggleMute,
      muted = _useMediaController.muted,
      requestVolume = _useMediaController.requestVolume,
      isVolumeChangeSupported = _useMediaController.isVolumeChangeSupported;

  var unmutedIcon = props.unmutedIcon,
      mutedIcon = props.mutedIcon,
      onClick = props.onClick,
      _props$showSlider = props.showSlider,
      showSlider = _props$showSlider === void 0 ? true : _props$showSlider,
      rest = _objectWithoutProperties(props, _excluded);

  var onClickComposed = React.useCallback( /*#__PURE__*/function () {
    var _ref2 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee(e) {
      return _regeneratorRuntime().wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              _context.next = 2;
              return onClick === null || onClick === void 0 ? void 0 : onClick(e);

            case 2:
              if (!showSlider && isVolumeChangeSupported) {
                if (muted) {
                  requestVolume(1);
                } else {
                  requestVolume(0);
                }
              } else {
                requestToggleMute();
              }

            case 3:
            case "end":
              return _context.stop();
          }
        }
      }, _callee);
    }));

    return function (_x) {
      return _ref2.apply(this, arguments);
    };
  }(), [onClick, requestToggleMute, requestVolume, showSlider, isVolumeChangeSupported, muted]);

  var _children = useConditionalIcon(!muted, unmutedIcon, /*#__PURE__*/React.createElement(DefaultUnmutedIcon, null), mutedIcon, /*#__PURE__*/React.createElement(DefaultMutedIcon, null));

  var title = React.useMemo(function () {
    return muted ? 'Unmute (m)' : 'Mute (m)';
  }, [muted]);
  return /*#__PURE__*/React.createElement("div", {
    className: styling.volume.container()
  }, /*#__PURE__*/React.createElement("button", _extends({
    className: styling.iconButton(),
    title: title,
    "aria-label": title,
    ref: ref,
    onClick: onClickComposed
  }, rest), _children), isVolumeChangeSupported && showSlider && /*#__PURE__*/React.createElement(VolumeProgress, null));
});
Volume.displayName = 'Volume';

var mediaControllerSelectorProgress = function mediaControllerSelectorProgress(_ref3) {
  var volume = _ref3.volume,
      requestVolume = _ref3.requestVolume,
      muted = _ref3.muted;
  return {
    volume: volume,
    requestVolume: requestVolume,
    muted: muted
  };
};

var VolumeProgress = function VolumeProgress() {
  var _useMediaController2 = useMediaController(mediaControllerSelectorProgress),
      volume = _useMediaController2.volume,
      requestVolume = _useMediaController2.requestVolume,
      muted = _useMediaController2.muted;

  var onChange = React.useCallback( /*#__PURE__*/function () {
    var _ref4 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee2(value) {
      return _regeneratorRuntime().wrap(function _callee2$(_context2) {
        while (1) {
          switch (_context2.prev = _context2.next) {
            case 0:
              requestVolume(value);

            case 1:
            case "end":
              return _context2.stop();
          }
        }
      }, _callee2);
    }));

    return function (_x2) {
      return _ref4.apply(this, arguments);
    };
  }(), [requestVolume]);
  return /*#__PURE__*/React.createElement(BaseSlider, {
    ariaName: "volume",
    value: muted ? 0 : volume,
    onChange: onChange
  });
};

function useLivepeerProvider() {
  return useSyncExternalStoreWithSelector(function (cb) {
    return watchLivepeerProvider(cb);
  }, function () {
    return getLivepeerProvider();
  }, function () {
    return getLivepeerProvider();
  }, function (x) {
    return x;
  });
}

var queryKey$5 = function queryKey(args, livepeerProvider) {
  return [{
    entity: 'getAsset',
    args: args,
    livepeerProvider: livepeerProvider
  }];
};
function useAsset(args) {
  var livepeerProvider = useLivepeerProvider();
  var getAssetArgs = useMemo(function () {
    var _args$assetId;

    return typeof args === 'string' ? args : {
      assetId: (_args$assetId = args === null || args === void 0 ? void 0 : args.assetId) !== null && _args$assetId !== void 0 ? _args$assetId : ''
    };
  }, [args]);
  return useInternalQuery(_objectSpread2({
    context: QueryClientContext,
    queryKey: queryKey$5(getAssetArgs, livepeerProvider),
    queryFn: function () {
      var _queryFn = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee() {
        return _regeneratorRuntime().wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                return _context.abrupt("return", getAsset(getAssetArgs));

              case 1:
              case "end":
                return _context.stop();
            }
          }
        }, _callee);
      }));

      function queryFn() {
        return _queryFn.apply(this, arguments);
      }

      return queryFn;
    }(),
    enabled: Boolean(typeof args === 'string' ? args : args === null || args === void 0 ? void 0 : args.assetId)
  }, _typeof(args) === 'object' ? pick(args, usePickQueryKeys) : {}));
}

function useCreateAsset(options) {
  var livepeerProvider = useLivepeerProvider();

  var _useState = useState(undefined),
      _useState2 = _slicedToArray(_useState, 2),
      uploadProgress = _useState2[0],
      setUploadProgress = _useState2[1];

  var internalQuery = useInternalMutation( /*#__PURE__*/function () {
    var _ref = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee(args) {
      return _regeneratorRuntime().wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              return _context.abrupt("return", createAsset(_objectSpread2(_objectSpread2({}, args), {}, {
                onUploadProgress: function onUploadProgress(progress) {
                  return setUploadProgress(progress === 1 ? undefined : progress);
                }
              })));

            case 1:
            case "end":
              return _context.stop();
          }
        }
      }, _callee);
    }));

    return function (_x) {
      return _ref.apply(this, arguments);
    };
  }(), _objectSpread2({
    context: QueryClientContext,
    mutationKey: [{
      entity: 'createAsset',
      livepeerProvider: livepeerProvider
    }]
  }, _typeof(options) === 'object' ? pick(options, usePickMutationKeys) : {}));
  return _objectSpread2(_objectSpread2({}, internalQuery), {}, {
    uploadProgress: uploadProgress
  });
}

function useUpdateAsset(options) {
  var livepeerProvider = useLivepeerProvider();
  return useInternalMutation( /*#__PURE__*/function () {
    var _ref = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee(args) {
      return _regeneratorRuntime().wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              return _context.abrupt("return", updateAsset(args));

            case 1:
            case "end":
              return _context.stop();
          }
        }
      }, _callee);
    }));

    return function (_x) {
      return _ref.apply(this, arguments);
    };
  }(), _objectSpread2({
    context: QueryClientContext,
    mutationKey: [{
      entity: 'updateAsset',
      livepeerProvider: livepeerProvider
    }]
  }, _typeof(options) === 'object' ? pick(options, usePickMutationKeys) : {}));
}

var queryKey$4 = function queryKey(args, livepeerProvider) {
  return [{
    entity: 'getAssetMetrics',
    args: args,
    livepeerProvider: livepeerProvider
  }];
};
function useAssetMetrics(args) {
  var livepeerProvider = useLivepeerProvider();
  var getAssetMetricsArgs = useMemo(function () {
    var _args$assetId;

    return {
      assetId: (_args$assetId = args === null || args === void 0 ? void 0 : args.assetId) !== null && _args$assetId !== void 0 ? _args$assetId : ''
    };
  }, [args]);
  return useInternalQuery(_objectSpread2({
    context: QueryClientContext,
    queryKey: queryKey$4(getAssetMetricsArgs, livepeerProvider),
    queryFn: function () {
      var _queryFn = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee() {
        return _regeneratorRuntime().wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                return _context.abrupt("return", getAssetMetrics(args));

              case 1:
              case "end":
                return _context.stop();
            }
          }
        }, _callee);
      }));

      function queryFn() {
        return _queryFn.apply(this, arguments);
      }

      return queryFn;
    }(),
    enabled: Boolean(args === null || args === void 0 ? void 0 : args.assetId)
  }, _typeof(args) === 'object' ? pick(args, usePickQueryKeys) : {}));
}

var queryKey$3 = function queryKey(args, livepeerProvider) {
  return [{
    entity: 'getPlaybackInfo',
    args: args,
    livepeerProvider: livepeerProvider
  }];
};
function usePlaybackInfo(args) {
  var livepeerProvider = useLivepeerProvider();
  var getPlaybackInfoArgs = useMemo(function () {
    var _args$playbackId;

    return typeof args === 'string' ? args : {
      playbackId: (_args$playbackId = args === null || args === void 0 ? void 0 : args.playbackId) !== null && _args$playbackId !== void 0 ? _args$playbackId : ''
    };
  }, [args]);
  return useInternalQuery(_objectSpread2({
    context: QueryClientContext,
    queryKey: queryKey$3(getPlaybackInfoArgs, livepeerProvider),
    queryFn: function () {
      var _queryFn = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee() {
        return _regeneratorRuntime().wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                return _context.abrupt("return", getPlaybackInfo(args));

              case 1:
              case "end":
                return _context.stop();
            }
          }
        }, _callee);
      }));

      function queryFn() {
        return _queryFn.apply(this, arguments);
      }

      return queryFn;
    }(),
    enabled: Boolean(typeof args === 'string' ? args : args === null || args === void 0 ? void 0 : args.playbackId)
  }, _typeof(args) === 'object' ? pick(args, usePickQueryKeys) : {}));
}

function useCreateStream(options) {
  var livepeerProvider = useLivepeerProvider();
  return useInternalMutation( /*#__PURE__*/function () {
    var _ref = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee(args) {
      return _regeneratorRuntime().wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              return _context.abrupt("return", createStream(args));

            case 1:
            case "end":
              return _context.stop();
          }
        }
      }, _callee);
    }));

    return function (_x) {
      return _ref.apply(this, arguments);
    };
  }(), _objectSpread2({
    context: QueryClientContext,
    mutationKey: [{
      entity: 'createStream',
      livepeerProvider: livepeerProvider
    }]
  }, _typeof(options) === 'object' ? pick(options, usePickMutationKeys) : {}));
}

var queryKey$2 = function queryKey(args, livepeerProvider) {
  return [{
    entity: 'getStream',
    args: args,
    livepeerProvider: livepeerProvider
  }];
};
function useStream(args) {
  var livepeerProvider = useLivepeerProvider();
  var getStreamArgs = useMemo(function () {
    var _args$streamId;

    return typeof args === 'string' ? args : {
      streamId: (_args$streamId = args === null || args === void 0 ? void 0 : args.streamId) !== null && _args$streamId !== void 0 ? _args$streamId : ''
    };
  }, [args]);
  return useInternalQuery(_objectSpread2({
    context: QueryClientContext,
    queryKey: queryKey$2(getStreamArgs, livepeerProvider),
    queryFn: function () {
      var _queryFn = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee() {
        return _regeneratorRuntime().wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                return _context.abrupt("return", getStream(getStreamArgs));

              case 1:
              case "end":
                return _context.stop();
            }
          }
        }, _callee);
      }));

      function queryFn() {
        return _queryFn.apply(this, arguments);
      }

      return queryFn;
    }(),
    enabled: Boolean(typeof args === 'string' ? args : args === null || args === void 0 ? void 0 : args.streamId)
  }, _typeof(args) === 'object' ? pick(args, usePickQueryKeys) : {}));
}

var queryKey$1 = function queryKey(args, livepeerProvider) {
  return [{
    entity: 'getStreamSession',
    args: args,
    livepeerProvider: livepeerProvider
  }];
};
function useStreamSession(args) {
  var livepeerProvider = useLivepeerProvider();
  var getStreamSessionArgs = useMemo(function () {
    var _args$streamSessionId;

    return typeof args === 'string' ? args : {
      streamSessionId: (_args$streamSessionId = args === null || args === void 0 ? void 0 : args.streamSessionId) !== null && _args$streamSessionId !== void 0 ? _args$streamSessionId : ''
    };
  }, [args]);
  return useInternalQuery(_objectSpread2({
    context: QueryClientContext,
    queryKey: queryKey$1(getStreamSessionArgs, livepeerProvider),
    queryFn: function () {
      var _queryFn = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee() {
        return _regeneratorRuntime().wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                return _context.abrupt("return", getStreamSession(getStreamSessionArgs));

              case 1:
              case "end":
                return _context.stop();
            }
          }
        }, _callee);
      }));

      function queryFn() {
        return _queryFn.apply(this, arguments);
      }

      return queryFn;
    }(),
    enabled: Boolean(typeof args === 'string' ? args : args === null || args === void 0 ? void 0 : args.streamSessionId)
  }, _typeof(args) === 'object' ? pick(args, usePickQueryKeys) : {}));
}

var queryKey = function queryKey(args, livepeerProvider) {
  return [{
    entity: 'getStreamSessions',
    args: args,
    livepeerProvider: livepeerProvider
  }];
};
function useStreamSessions(args) {
  var livepeerProvider = useLivepeerProvider();
  var getStreamSessionsArgs = useMemo(function () {
    var _args$streamId;

    return typeof args === 'string' ? args : {
      streamId: (_args$streamId = args === null || args === void 0 ? void 0 : args.streamId) !== null && _args$streamId !== void 0 ? _args$streamId : ''
    };
  }, [args]);
  return useInternalQuery(_objectSpread2({
    context: QueryClientContext,
    queryKey: queryKey(getStreamSessionsArgs, livepeerProvider),
    queryFn: function () {
      var _queryFn = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee() {
        return _regeneratorRuntime().wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                return _context.abrupt("return", getStreamSessions(getStreamSessionsArgs));

              case 1:
              case "end":
                return _context.stop();
            }
          }
        }, _callee);
      }));

      function queryFn() {
        return _queryFn.apply(this, arguments);
      }

      return queryFn;
    }(),
    enabled: Boolean(typeof args === 'string' ? args : args === null || args === void 0 ? void 0 : args.streamId)
  }, _typeof(args) === 'object' ? pick(args, usePickQueryKeys) : {}));
}

function useUpdateStream(options) {
  var livepeerProvider = useLivepeerProvider();
  return useInternalMutation( /*#__PURE__*/function () {
    var _ref = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee(args) {
      return _regeneratorRuntime().wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              return _context.abrupt("return", updateStream(args));

            case 1:
            case "end":
              return _context.stop();
          }
        }
      }, _callee);
    }));

    return function (_x) {
      return _ref.apply(this, arguments);
    };
  }(), _objectSpread2({
    context: QueryClientContext,
    mutationKey: [{
      entity: 'updateStream',
      livepeerProvider: livepeerProvider
    }]
  }, _typeof(options) === 'object' ? pick(options, usePickMutationKeys) : {}));
}

var mediaControllerSelector$2 = function mediaControllerSelector(_ref) {
  var fullscreen = _ref.fullscreen;
  return {
    fullscreen: fullscreen
  };
};

var AudioPlayer = /*#__PURE__*/React.forwardRef(function (_ref2, ref) {
  var src = _ref2.src,
      autoPlay = _ref2.autoPlay,
      title = _ref2.title,
      loop = _ref2.loop,
      muted = _ref2.muted,
      objectFit = _ref2.objectFit;

  var _useMediaController = useMediaController(mediaControllerSelector$2),
      fullscreen = _useMediaController.fullscreen;

  var filteredSources = React.useMemo(function () {
    return src.filter(function (s) {
      return (s === null || s === void 0 ? void 0 : s.mime) && canPlayMediaNatively(s.mime);
    });
  }, [src]);
  return /*#__PURE__*/React.createElement("audio", {
    className: styling.media.audio({
      size: fullscreen ? 'fullscreen' : objectFit
    }),
    loop: loop,
    "aria-label": title !== null && title !== void 0 ? title : 'Audio player',
    role: "audio",
    autoPlay: autoPlay,
    ref: ref,
    "webkit-playsinline": "true",
    playsInline: true,
    muted: muted
  }, filteredSources.map(function (source) {
    return /*#__PURE__*/React.createElement("source", {
      key: source.src,
      src: source.src,
      type: source.mime
    });
  }), "Your browser doesn't support the HTML5 <code>audio</code> tag, or the audio format.");
});
AudioPlayer.displayName = 'AudioPlayer';

var mediaControllerSelector$1 = function mediaControllerSelector(_ref) {
  var fullscreen = _ref.fullscreen;
  return {
    fullscreen: fullscreen
  };
};

var VideoPlayer = /*#__PURE__*/React.forwardRef(function (_ref2, ref) {
  var src = _ref2.src,
      autoPlay = _ref2.autoPlay,
      title = _ref2.title,
      loop = _ref2.loop,
      muted = _ref2.muted,
      poster = _ref2.poster,
      objectFit = _ref2.objectFit;

  var _useMediaController = useMediaController(mediaControllerSelector$1),
      fullscreen = _useMediaController.fullscreen;

  var filteredSources = React.useMemo(function () {
    return src === null || src === void 0 ? void 0 : src.filter(function (s) {
      return (s === null || s === void 0 ? void 0 : s.mime) && canPlayMediaNatively(s.mime);
    });
  }, [src]);
  return /*#__PURE__*/React.createElement("video", {
    className: styling.media.video({
      size: fullscreen ? 'fullscreen' : objectFit
    }),
    loop: loop,
    "aria-label": title !== null && title !== void 0 ? title : 'Video player',
    role: "video",
    autoPlay: autoPlay,
    width: "100%",
    height: "100%",
    ref: ref,
    "webkit-playsinline": "true",
    playsInline: true,
    muted: muted,
    poster: poster
  }, filteredSources === null || filteredSources === void 0 ? void 0 : filteredSources.map(function (source) {
    return /*#__PURE__*/React.createElement("source", {
      key: source.src,
      src: source.src,
      type: source.mime
    });
  }), "Your browser doesn't support the HTML5 <code>video</code> tag, or the video format.");
});
VideoPlayer.displayName = 'VideoPlayer';

var mediaControllerSelector = function mediaControllerSelector(_ref) {
  var _element = _ref._element,
      fullscreen = _ref.fullscreen,
      setLive = _ref.setLive,
      onDurationChange = _ref.onDurationChange,
      onCanPlay = _ref.onCanPlay;
  return {
    element: _element,
    fullscreen: fullscreen,
    setLive: setLive,
    onDurationChange: onDurationChange,
    onCanPlay: onCanPlay
  };
};

var HlsPlayer = /*#__PURE__*/React.forwardRef(function (props, ref) {
  var hlsConfig = props.hlsConfig,
      src = props.src,
      autoPlay = props.autoPlay,
      title = props.title,
      loop = props.loop,
      muted = props.muted,
      poster = props.poster,
      objectFit = props.objectFit;

  var _useMediaController = useMediaController(mediaControllerSelector),
      element = _useMediaController.element,
      fullscreen = _useMediaController.fullscreen,
      setLive = _useMediaController.setLive,
      onDurationChange = _useMediaController.onDurationChange,
      onCanPlay = _useMediaController.onCanPlay;

  var _React$useMemo = React.useMemo(function () {
    return [isHlsSupported(), canPlayMediaNatively('application/vnd.apple.mpegurl')];
  }, []),
      _React$useMemo2 = _slicedToArray(_React$useMemo, 2),
      canUseHlsjs = _React$useMemo2[0],
      canPlayAppleMpeg = _React$useMemo2[1];

  React.useEffect(function () {
    if (element && canUseHlsjs && !canPlayAppleMpeg && src) {
      var _createNewHls = createNewHls(src, element, setLive, onDurationChange, onCanPlay, _objectSpread2({
        autoplay: autoPlay
      }, hlsConfig)),
          destroy = _createNewHls.destroy;

      return function () {
        destroy();
      };
    }
  }, [autoPlay, hlsConfig, src, element, canUseHlsjs, canPlayAppleMpeg, setLive, onDurationChange, onCanPlay]); // if Media Source is supported and if HLS is not supported by default in the user's browser, use HLS.js
  // fallback to using a regular video player

  return !canPlayAppleMpeg && canUseHlsjs ? /*#__PURE__*/React.createElement("video", {
    className: styling.media.video({
      size: fullscreen ? 'fullscreen' : objectFit
    }),
    loop: loop,
    "aria-label": title !== null && title !== void 0 ? title : 'Video player',
    role: "video",
    width: "100%",
    height: "100%",
    ref: ref,
    "webkit-playsinline": "true",
    playsInline: true,
    autoPlay: autoPlay,
    muted: muted,
    poster: poster
  }) : /*#__PURE__*/React.createElement(VideoPlayer, _extends({}, props, {
    ref: ref,
    src: [_objectSpread2(_objectSpread2({}, src), {}, {
      type: 'video'
    })]
  }));
});
HlsPlayer.displayName = 'HlsPlayer';

function Player(_ref) {
  var _sourceMimeTyped$2;

  var autoPlay = _ref.autoPlay,
      children = _ref.children,
      controls = _ref.controls,
      muted = _ref.muted,
      playbackId = _ref.playbackId,
      _ref$refetchPlaybackI = _ref.refetchPlaybackInfoInterval,
      refetchPlaybackInfoInterval = _ref$refetchPlaybackI === void 0 ? 5000 : _ref$refetchPlaybackI,
      src = _ref.src,
      theme = _ref.theme,
      title = _ref.title,
      poster = _ref.poster,
      loop = _ref.loop,
      _ref$showLoadingSpinn = _ref.showLoadingSpinner,
      showLoadingSpinner = _ref$showLoadingSpinn === void 0 ? true : _ref$showLoadingSpinn,
      _ref$showTitle = _ref.showTitle,
      showTitle = _ref$showTitle === void 0 ? true : _ref$showTitle,
      _ref$aspectRatio = _ref.aspectRatio,
      aspectRatio = _ref$aspectRatio === void 0 ? '16to9' : _ref$aspectRatio,
      _ref$objectFit = _ref.objectFit,
      objectFit = _ref$objectFit === void 0 ? 'cover' : _ref$objectFit;

  var _React$useState = React.useState(null),
      _React$useState2 = _slicedToArray(_React$useState, 2),
      mediaElement = _React$useState2[0],
      setMediaElement = _React$useState2[1];

  var _usePlaybackInfo = usePlaybackInfo({
    playbackId: playbackId !== null && playbackId !== void 0 ? playbackId : undefined,
    refetchInterval: function refetchInterval(info) {
      return info ? false : refetchPlaybackInfoInterval;
    },
    enabled: !src && Boolean(playbackId)
  }),
      playbackInfo = _usePlaybackInfo.data;

  var _React$useState3 = React.useState([]),
      _React$useState4 = _slicedToArray(_React$useState3, 2),
      playbackUrls = _React$useState4[0],
      setPlaybackUrls = _React$useState4[1];

  React.useEffect(function () {
    var _playbackInfo$meta, _playbackInfo$meta$so, _playbackInfo$meta$so2;

    var playbackInfoSources = playbackInfo === null || playbackInfo === void 0 ? void 0 : (_playbackInfo$meta = playbackInfo.meta) === null || _playbackInfo$meta === void 0 ? void 0 : (_playbackInfo$meta$so = _playbackInfo$meta.source) === null || _playbackInfo$meta$so === void 0 ? void 0 : (_playbackInfo$meta$so2 = _playbackInfo$meta$so.map(function (s) {
      return s === null || s === void 0 ? void 0 : s.url;
    })) === null || _playbackInfo$meta$so2 === void 0 ? void 0 : _playbackInfo$meta$so2.filter(function (s) {
      return s;
    });

    if (playbackInfoSources) {
      setPlaybackUrls(playbackInfoSources);
    }
  }, [playbackInfo]);
  var sourceMimeTyped = React.useMemo(function () {
    var _mediaSourceTypes$, _mediaSourceTypes$2, _mediaSourceTypes$3;

    var sourceOrPlaybackInfoSrc = playbackUrls.length > 0 ? playbackUrls : typeof src === 'string' ? [src] : src;

    if (!sourceOrPlaybackInfoSrc) {
      return null;
    }

    var mediaSourceTypes = sourceOrPlaybackInfoSrc.map(function (s) {
      return typeof s === 'string' ? getMediaSourceType(s) : s;
    }).filter(function (s) {
      return s;
    }); // if there are multiple Hls sources, we take only the first one
    // otherwise we pass all sources to the video or audio player components

    if (mediaSourceTypes.every(function (s) {
      return s.type === 'hls';
    }) && (mediaSourceTypes === null || mediaSourceTypes === void 0 ? void 0 : (_mediaSourceTypes$ = mediaSourceTypes[0]) === null || _mediaSourceTypes$ === void 0 ? void 0 : _mediaSourceTypes$.type) === 'hls') {
      return mediaSourceTypes[0];
    } // we filter by the first source type in the array provided


    var mediaSourceFiltered = (mediaSourceTypes === null || mediaSourceTypes === void 0 ? void 0 : (_mediaSourceTypes$2 = mediaSourceTypes[0]) === null || _mediaSourceTypes$2 === void 0 ? void 0 : _mediaSourceTypes$2.type) === 'audio' ? mediaSourceTypes.filter(function (s) {
      return s.type === 'audio';
    }) : (mediaSourceTypes === null || mediaSourceTypes === void 0 ? void 0 : (_mediaSourceTypes$3 = mediaSourceTypes[0]) === null || _mediaSourceTypes$3 === void 0 ? void 0 : _mediaSourceTypes$3.type) === 'video' ? mediaSourceTypes.filter(function (s) {
      return s.type === 'video';
    }) : null;
    return mediaSourceFiltered;
  }, [playbackUrls, src]);
  var hidePosterOnPlayed = React.useMemo(function () {
    var _sourceMimeTyped$;

    return Array.isArray(sourceMimeTyped) ? (sourceMimeTyped === null || sourceMimeTyped === void 0 ? void 0 : (_sourceMimeTyped$ = sourceMimeTyped[0]) === null || _sourceMimeTyped$ === void 0 ? void 0 : _sourceMimeTyped$.type) !== 'audio' ? true : undefined : undefined;
  }, [sourceMimeTyped]);
  var playerRef = React.useCallback(function (element) {
    if (element) {
      setMediaElement(element);
    }
  }, []);
  var contextTheme = useTheme(theme);
  return /*#__PURE__*/React.createElement(MediaControllerProvider, {
    element: mediaElement,
    options: controls
  }, /*#__PURE__*/React.createElement(Container, {
    className: contextTheme,
    aspectRatio: aspectRatio
  }, sourceMimeTyped && !Array.isArray(sourceMimeTyped) ? /*#__PURE__*/React.createElement(HlsPlayer, {
    ref: playerRef,
    autoPlay: autoPlay,
    muted: autoPlay ? true : muted,
    src: sourceMimeTyped,
    poster: typeof poster === 'string' ? poster : undefined,
    loop: loop,
    objectFit: objectFit
  }) : (sourceMimeTyped === null || sourceMimeTyped === void 0 ? void 0 : (_sourceMimeTyped$2 = sourceMimeTyped[0]) === null || _sourceMimeTyped$2 === void 0 ? void 0 : _sourceMimeTyped$2.type) === 'audio' ? /*#__PURE__*/React.createElement(AudioPlayer, {
    ref: playerRef,
    autoPlay: autoPlay,
    muted: autoPlay ? true : muted,
    src: sourceMimeTyped,
    loop: loop,
    objectFit: objectFit
  }) : /*#__PURE__*/React.createElement(VideoPlayer, {
    ref: playerRef,
    autoPlay: autoPlay,
    muted: autoPlay ? true : muted,
    src: sourceMimeTyped,
    poster: typeof poster === 'string' ? poster : undefined,
    loop: loop,
    objectFit: objectFit
  }), /*#__PURE__*/React.isValidElement(children) ? children : /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(ControlsContainer, {
    hidePosterOnPlayed: hidePosterOnPlayed,
    showLoadingSpinner: showLoadingSpinner,
    poster: poster && /*#__PURE__*/React.createElement(Poster, {
      content: poster,
      title: title
    }),
    top: /*#__PURE__*/React.createElement(React.Fragment, null, title && showTitle && /*#__PURE__*/React.createElement(Title, {
      content: title
    })),
    middle: /*#__PURE__*/React.createElement(Progress, null),
    left: /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(PlayButton, null), /*#__PURE__*/React.createElement(Volume, null), /*#__PURE__*/React.createElement(TimeDisplay, null)),
    right: /*#__PURE__*/React.createElement(FullscreenButton, null)
  }))));
}

export { ControlsContainer, FullscreenButton, MediaControllerProvider, PlayButton, Player, Poster, Progress, TimeDisplay, Title, Volume, createReactClient, deserialize, serialize, useAsset, useAssetMetrics, useCreateAsset, useCreateStream, useLivepeerProvider, useMediaController, useStream, useStreamSession, useStreamSessions, useTheme, useUpdateAsset, useUpdateStream };
